import React from 'react';
import "../../styles/chats/reaction_dialog.css";
import { useSearchContext } from "./searchContext";

const ReactionDialog = (isReactionDropDownShow) => {
    const {setSelectedEmoji} = useSearchContext();

    const onSelectEmoji = (em) => {
        setSelectedEmoji(em)
    };

    return(
        <div className={`reation_dialog ${isReactionDropDownShow ? "show" : ""}`}>
            <p onClick={() => onSelectEmoji("👍")}><span role='img' aria-label='thumbs up'>👍</span></p>
            <p onClick={() => onSelectEmoji("👎")}><span role='img' aria-label='thumbs down'>👎</span></p>
            <p onClick={() => onSelectEmoji("😂")}><span role='img' aria-label='laughing'>😂</span></p>
            <p onClick={() => onSelectEmoji("😭")}><span role='img' aria-label='crying'>😭</span></p>
            <p onClick={() => onSelectEmoji("😍")}><span role='img' aria-label='heart eyes'>😍</span></p>
            <p onClick={() => onSelectEmoji("🤩")}><span role='img' aria-label='star struck'>🤩</span></p>
            <p onClick={() => onSelectEmoji("🫣")}><span role='img' aria-label='face with hand over mouth'>🫣</span></p>
            <p onClick={() => onSelectEmoji("😐")}><span role='img' aria-label='neutral face'>😐</span></p>
            <p onClick={() => onSelectEmoji("😠")}><span role='img' aria-label='angry face'>😠</span></p>
            <p onClick={() => onSelectEmoji("😊")}><span role='img' aria-label='smiling face with smiling eyes'>😊</span></p>
            <p onClick={() => onSelectEmoji("💖")}><span role='img' aria-label='sparkling heart'>💖</span></p>
            <p onClick={() => onSelectEmoji("💔")}><span role='img' aria-label='broken heart'>💔</span></p>
        </div>
    );
}

export default ReactionDialog;